import React, { useCallback, useMemo } from "react";
import clsx from "clsx";
import FTLPaginationButton from "./FTLPaginationButton";
import { Box, makeStyles, useMediaQuery } from "@material-ui/core";
import FTLTypography from "../FTLTypography";
import FTLSelect from "../../fields/FTLSelect";
import { FTLShortcutUtils, useShortcut } from "ftl-core";
import { ArrowDownIcon } from "../../icons";
const pageSizeOptions = [
    { label: "5", value: 5 },
    { label: "10", value: 10 },
    { label: "20", value: 20 },
];
const getVisiblePages = (pageIndex, totalPages, maxPages = 5) => {
    const pages = [];
    const nextPageNumber = pageIndex + 2;
    const startPage = nextPageNumber > maxPages && totalPages > maxPages
        ? totalPages < nextPageNumber
            ? totalPages - maxPages + 1
            : nextPageNumber - maxPages + 1
        : 1;
    for (let i = 0; i < maxPages; i++) {
        if (i + startPage > totalPages)
            break;
        pages.push(i + startPage);
    }
    return pages;
};
FTLShortcutUtils.register("tableNextPage", {
    default: "Equal",
    label: "След. страница таблицы",
});
FTLShortcutUtils.register("tablePrevPage", {
    default: "Minus",
    label: "Пред. страница таблицы",
});
export default ({ pageIndex, pageSize, pageCount, disabled, setPageSize, gotoPage = () => { }, className, }) => {
    const classes = useStyles();
    const pages = Math.ceil(pageCount / pageSize);
    const getPages = useCallback((page) => {
        if (pages < page)
            return getVisiblePages(pages, pages);
        else
            return getVisiblePages(page, pages);
    }, [pageSize, pageCount]);
    const pageComponents = useMemo(() => {
        const visiblePages = getPages(pageIndex);
        return visiblePages.map((pageNumber) => {
            return (React.createElement(FTLPaginationButton, { isSelected: pageIndex + 1 === pageNumber, disabled: pageNumber > pages || disabled, onClick: () => {
                    if (pageIndex + 1 !== pageNumber) {
                        gotoPage(pageNumber);
                    }
                }, key: pageNumber }, pageNumber));
        });
    }, [getPages, pageIndex, gotoPage]);
    useShortcut("tableNextPage", () => {
        if (pageIndex + 1 < pages)
            gotoPage(pageIndex + 2);
    });
    useShortcut("tablePrevPage", () => {
        if (pageIndex > 0)
            gotoPage(pageIndex);
    });
    const mobile = useMediaQuery((theme) => theme.breakpoints.down("xs"));
    return (React.createElement("div", { className: clsx(classes.root, className) },
        React.createElement("div", { className: classes.container, style: pageCount ? {} : { display: "none" } },
            React.createElement(FTLTypography, { variant: "listItemText" }, `Всего: ${pageCount}`),
            React.createElement(Box, { marginLeft: 6, display: "flex", alignItems: "center" },
                React.createElement(FTLTypography, { variant: "listItemText" }, "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435:"),
                React.createElement(FTLSelect, { searchable: false, disableClearable: true, size: "small", value: { label: String(pageSize), value: pageSize }, inputVariant: "standard", onChange: (option) => {
                        if (option.value !== pageSize) {
                            gotoPage(1);
                            setPageSize(option === null || option === void 0 ? void 0 : option.value);
                        }
                    }, options: pageSizeOptions, BoxProps: {
                        maxWidth: 60,
                    } }))),
        React.createElement("div", { className: classes.paginationContainer },
            React.createElement(FTLPaginationButton, { onClick: () => {
                    gotoPage(1);
                }, style: {
                    width: "86px",
                    // display: pageIndex + 2 >= 5 && pages > 5 ? "flex" : "none",
                }, disabled: (pageIndex + 1 > 1 && pages ? false : true) || disabled }, "\u0412 \u043D\u0430\u0447\u0430\u043B\u043E"),
            React.createElement(FTLPaginationButton, { paginationType: "icon", disabled: (pageIndex >= 1 ? false : true) || disabled, onClick: () => {
                    gotoPage(pageIndex);
                } },
                React.createElement(ArrowDownIcon, { style: {
                        transform: "rotate(90deg)",
                        marginRight: 10,
                        marginLeft: 10,
                    } })),
            pageComponents,
            React.createElement(FTLPaginationButton, { paginationType: "icon", disabled: (pageIndex < pages - 1 ? false : true) || disabled, onClick: () => {
                    gotoPage(pageIndex + 2);
                } },
                React.createElement(ArrowDownIcon, { style: {
                        transform: "rotate(-90deg)",
                        marginRight: 10,
                        marginLeft: 10,
                    } })),
            React.createElement(FTLPaginationButton, { style: {
                    width: "86px",
                    marginRight: "0",
                }, onClick: () => {
                    gotoPage(pages);
                }, disabled: (pageIndex < pages - 1 && !mobile ? false : true) || disabled }, "\u0412 \u043A\u043E\u043D\u0435\u0446"))));
};
const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 4,
        position: "absolute",
        bottom: 0,
        background: "#ffffff",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "80px",
        borderTop: "2px solid #ebedf0",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            justifyContent: "center",
            height: "auto",
        },
    },
    container: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(4),
        },
    },
    pageSizeContainer: {
        display: "flex",
        alignItems: "center",
    },
    pageSizeWrapper: {
        cursor: "pointer",
        marginLeft: "8px",
    },
    pageSizeIcon: {
        marginLeft: "16px",
        width: "20px",
        height: "20px",
    },
    paginationContainer: {
        display: "flex",
        alignItems: "center",
        "& > button": {
            width: "32px",
            margin: "4px",
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing(6),
        },
    },
    listItem: Object.assign(Object.assign({}, theme.typography.listItemText), { backgroundColor: "#fff", color: theme.palette.text.primary, cursor: "pointer", outline: "none", "&:hover": {
            backgroundColor: "#f5f5f6",
        } }),
}));
//# sourceMappingURL=FTLTableFooter.js.map